import { render } from "./UserForm.vue?vue&type=template&id=487130f9&scoped=true"
import script from "./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue?vue&type=script&lang=js"

import "./UserForm.vue?vue&type=style&index=0&id=487130f9&scoped=true&lang=css"
import "./UserForm.vue?vue&type=style&index=1&id=487130f9&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487130f9"]])

export default __exports__